
import React, { useEffect, useState } from 'react'
import Content from "../../../Components/Dashboard/Content/Content"
import Loader from '../../../Utils/Loader'

import FullDataTable from "../../../Components/ExtraComponents/Datatable/FullDataTable"
import { GetAllDeletedSignal, BackupSignal, Undo_signal } from '../../../ReduxStore/Slice/Superadmin/SuperAdminSlice'
import { useDispatch, useSelector } from "react-redux";
import Modal from '../../../Components/ExtraComponents/Modal';
import { fa_time, fDateTimeSuffix, today } from "../../../Utils/Date_formet";
import { useLocation, useNavigate } from 'react-router-dom';
import { RotateCcw, Pencil, Undo2 } from 'lucide-react';
import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";
import toast from 'react-hot-toast';
import Swal from "sweetalert2";


const AdminHelps = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    let location = useLocation();
    let admin_details = location.state
    const user_id = JSON.parse(localStorage.getItem("user_details"))
    const backend_rul = localStorage.getItem("backend_rul");
    const token = JSON.parse(localStorage.getItem("user_details")).token
    const UserName = JSON.parse(localStorage.getItem("user_details")).UserName
    const panel_name = localStorage.getItem("panel_name");
    const [refresh, setRefresh] = useState(false)


    const [getDeleteSignals, setDeletSignals] = useState({
        loading: true,
        data: []
    });

    const data = async () => {
        const data = { backend_rul: backend_rul }
        await dispatch(GetAllDeletedSignal(data)).unwrap()
            .then((response) => {
                if (response.status) {
                    setDeletSignals({
                        loading: false,
                        data: response.data
                    });
                } else {
                    setDeletSignals({
                        loading: false,
                        data: []
                    });
                }
            })
    }


    useEffect(() => {
        data()
    }, [refresh])


    const handleDelete = async (id) => {
        const data = { id: id, backend_rul: backend_rul, superadmin_name: UserName, panel_name: panel_name }
        await dispatch(BackupSignal(data)).unwrap()
            .then((response) => {
                if (response.status) {
                    toast.success("Signal Backup successfully")
                    setRefresh(!refresh)
                }
                else {
                    toast.error("some error finds")
                }
            }).catch((err) => {
                return;
            })


    }

    const formatISTDateTime = (value) => {
        if (!value) return "";

        const date = new Date(value);
        const options = { timeZone: "Asia/Kolkata", hour12: false };

        const d = date.toLocaleDateString("en-CA", options); // YYYY-MM-DD
        const t = date.toLocaleTimeString("en-IN", options); // HH:mm:ss (24-hour)

        return `${d} ${t}`;
    };
    
    const handleUndo = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to undo this signal?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2e7d32",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Undo it",
            cancelButtonText: "Cancel",
        });

        if (!result.isConfirmed) return;

        const data = {
            id: id,
            backend_rul: backend_rul,
            superadmin_name: UserName,
            panel_name: panel_name,
        };

        dispatch(Undo_signal(data))
            .unwrap()
            .then((response) => {
                if (response.status) {
                    Swal.fire(
                        "Undo Successful!",
                        "Signal has been restored successfully.",
                        "success"
                    );
                    setRefresh(!refresh);
                } else {
                    Swal.fire(
                        "Failed!",
                        response.msg || "Undo failed",
                        "error"
                    );
                }
            })
            .catch(() => {
                Swal.fire(
                    "Error!",
                    "Something went wrong",
                    "error"
                );
            });
    };



    const columns = [

        {
            dataField: "index",
            text: "SR. No.",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: 'symbol',
            text: 'Symbol'
        },
        {
            dataField: 'strategy',
            text: 'Strategy'
        },
        {
            dataField: 'entryType',
            text: 'Entry Type'
        },
        {
            dataField: 'entryPrice',
            text: 'Entry Price',

        },
        {
            dataField: 'exitPrice',
            text: 'Exit Price',

        },
        {
            dataField: 'quantity',
            text: ' Quantity'
        },
        {
            dataField: 'entryTime',
            text: "Created",
            formatter: (cell) => <div>{formatISTDateTime(cell)}</div>
        },
        {
            dataField: 'createdAt',
            text: 'Deleted',
            formatter: (cell) => <div>{formatISTDateTime(cell)}</div>,
            "width": '200px'
        },

        {
            dataField: '',
            text: 'Action',
            formatter: (cell, row) => (
                <div style={{ display: "flex", gap: "10px" }}>

                    {/* Existing Backup / Delete */}
                    {/* <RotateCcw
                        size={18}
                        style={{ cursor: "pointer", color: "#ff9800" }}
                        title="Backup Signal"
                        onClick={() => handleDelete(row._id)}
                    /> */}

                    {/* NEW UNDO BUTTON */}
                    <Undo2
                        size={26}
                        style={{ cursor: "pointer", color: "#2e7d32" }}
                        title="Undo Signal"
                        onClick={() => handleUndo(row._id)}
                    />

                </div>
            ),
        },


    ];

    const handleBackupBtn = () => {
        navigate('/super/signals')
    }

    return (
        <>
            {
                getDeleteSignals.loading ? <Loader /> :
                    <>
                        <Content Page_title="Deleted Signal" button_status={true} button_title='Back' route='/super/signals'>
                            <div>
                                <button className='btn btn-primary mb-3' onClick={handleBackupBtn}>Signal</button>
                            </div>
                            <FullDataTable TableColumns={columns} tableData={getDeleteSignals.data} pagination1={false} />
                        </Content>
                    </>
            }


        </ >
    )
}


export default AdminHelps
